import { useSessionStore } from '@systemeio/util'

const WAITED_SHARING_IDS_LOCALE_STORAGE_KEY = 'WAITED_SHARING_IDS_LOCALE_STORAGE_KEY'

export const useWaitedSharingIdsStorage = () => {
  const { getItem, setItem, removeItem } = useSessionStore<Set<string>>(
    WAITED_SHARING_IDS_LOCALE_STORAGE_KEY,
    {
      parser: value => new Set(JSON.parse(value)),
      stringifier: value => JSON.stringify(Array.from(value)),
    },
  )

  const addSharingId = (sharingId: string) => {
    const ids = getItem() ?? new Set()
    ids.add(sharingId)
    setItem(ids)
  }

  return {
    getItem,
    setItem,
    removeItem,
    addSharingId,
  }
}
